<div>
    <div *ngIf="dataReady">

            <div>
                <div style="display: flex; align-items: center">
                    <div style="flex-grow: 0">
                        <h3>Aggiorna come</h3>
                    </div>
                    <div style="margin-left: 2em">
                        <p-dropdown styleClass="form_select_mid" appendTo="body" [options]='opzioniAzioneStato' [(ngModel)]="edit_stato" placeholder="soluzione" (onChange)="validateForm()"></p-dropdown>
                    </div>
                    <div style="flex-grow: 1; margin-left: 1em" [ngSwitch]="edit_stato">
                        <span *ngSwitchCase="StatoDiscrepanza.NONCONFERMATA">
                            La segnalazione verrà considerata errata e i movimenti di materiali confermati come da movimentazione originale.
                        </span>
                        <span *ngSwitchCase="StatoDiscrepanza.RISOLTA">
                            La segnalazione verrà confermata in tutto o in parte e i materiali riallocati in base al correttivo indicato da form<span *ngIf="fixIsPartial"> (la riallocazione attualmente indicata è solo parziale)</span>. NOTA: si può inserire una sola risoluzione per ogni discrepanza.
                        </span>
                    </div>
                </div>
            </div>


            <p-table styleClass="p-datatable-sm" [value]="edits_materiali" dataKey="id"
                     responsiveLayout="stack">

                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="id">
                                <div class="flex justify-content-between align-items-center">
                                    NMU
                                </div>
                            </th>
                            <th>
                                <div class="flex justify-content-between align-items-center">
                                    descrizione
                                </div>
                            </th>
                            <th>
                                <div class="flex justify-content-between align-items-center">
                                    mancanti
                                </div>
                            </th>
                            <th  *ngIf="edit_stato == StatoDiscrepanza.RISOLTA">
                                <div class="flex justify-content-between align-items-center">
                                    correttivo
                                </div>
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-row>
                        <tr>

                            <td><span class="text-lowercase">{{ row.modello.nmu }}</span></td>
                            <td style="width: 100%"><span class="text-lowercase">{{ row.modello.descrizione }}</span></td>
                            <td><span class="text-lowercase">
                                {{materialiById[row.modello.id].srcdelta ?? 0}}
                            </span></td>
                            <td *ngIf="edit_stato == StatoDiscrepanza.RISOLTA">
                                <p-inputNumber [(ngModel)]="row.qt" [showButtons]="true" buttonLayout="horizontal" inputId="horizontal" [step]="1" [min]="0" [max]="materialiById[row.modello.id].srcdelta" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" [size]="5" (onInput)="validateForm()">
                                </p-inputNumber>
                            </td>
                        </tr>
                    </ng-template>
            </p-table>


        <p-divider type="solid"></p-divider>

        <div class="dialog_controls">

            <p-button icon="pi pi-times" label="Annulla" class="p-button-text mr-1 row_button" (click)="onActivityCompleted(false)"></p-button>
            <p-button icon="pi pi-check" label="Conferma" class="p-button-text ml-100 row_button" styleClass="p-button-success" (click)="onActivityCompleted(true)" [disabled]="!hasValidForm"></p-button>
        </div>


    </div>
</div>
